import React from 'react'

const EzcancelPlusIcon = ({ width, height }) => {
  return (
    <svg width={width} height={height} viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
      <g style={{ mixBlendMode: 'darken' }}>
        <rect width="26" height="26" fill="url(#pattern0)" />
      </g>
      <defs>
        <pattern id="pattern0" patternContentUnits="objectBoundingBox" width="1" height="1">
          <use xlinkHref="#image0_666_2452" transform="translate(-0.0107034) scale(0.00152905)" />
        </pattern>
      </defs>
    </svg>
  )
}

export default EzcancelPlusIcon
